import React, { useState } from 'react';
import { Modal, Box, Button, Typography } from '@mui/material';
import { SketchPicker } from 'react-color';

const ColorPickerModal = ({ currentColor = '#FFFFFF', modalVisible, setModalVisible, setColor, buttonColor }) => {
  const [selectedColor, setSelectedColor] = useState(currentColor);

  const onColorChange = (color) => {
    setSelectedColor(color.hex);
  };

  const onColorCompleted = () => {
    // Handle color selection complete if needed
  };

  return (
    <Modal
      open={modalVisible}
      onClose={() => setModalVisible(false)}
      aria-labelledby="color-picker-title"
      aria-describedby="color-picker-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography id="color-picker-title" variant="h6" component="h2" sx={{ backgroundColor: buttonColor, color: '#FFFFFF', width: '100%', textAlign: 'center', padding: 2 }}>
          Color Picker
        </Typography>
        <SketchPicker
          color={selectedColor}
          onChange={onColorChange}
          onChangeComplete={onColorCompleted}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 2 }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: buttonColor, color: '#FFFFFF' }}
            onClick={() => setModalVisible(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: buttonColor, color: '#FFFFFF' }}
            onClick={() => {
              setColor(selectedColor);
              setModalVisible(false);
            }}
          >
            OK
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ColorPickerModal;
